import { csMessages, Toaster, ToolkitProvider } from '@ox-technologies/ui';
import { Outlet } from '@tanstack/react-router';
import { useStoredPath } from 'utils/hooks/use-stored-path';

// Root route component. The public/protected chrome is chosen by route (see
// the pathless `public` and `protected` layout routes in router.tsx), NOT by
// auth state — otherwise a dev CUSTOM_AUTH_TOKEN would swap the login page's
// branded shell for the signed-in app chrome.
const Layout: React.FC = () => {
  // Stores/restores the intended path around the OIDC login flow. Lives here
  // (the root route component) because it needs the router context.
  useStoredPath();

  return (
    // ToolkitProvider supplies the toolkit components' built-in strings
    // (modal close buttons, empty states, password-reveal and OTP-slot
    // aria-labels, …) — since @ox-technologies/ui 3.0.0 the library ships no
    // hardcoded language. The app is Czech-only (i18n.ts), so the shipped
    // Czech pack is used directly.
    <ToolkitProvider messages={csMessages}>
      <Outlet />
      <Toaster />
    </ToolkitProvider>
  );
};

export default Layout;
